import React from 'react';
import { nanoid } from 'nanoid';
import { StyledButton, StyledContainer } from './Island.styles';
import { IslandButtonProps, IslandProps } from './types';
import { Tooltip } from '../Tooltip';

export const IslandButton: React.FC<IslandButtonProps> = ({
  tooltipContent,
  content,
  $active = false,
  $static = false,
  $disabled = false,
  children,
  ...rest
}) => {
  const id = nanoid();

  return (
    <>
      <StyledButton
        data-tooltip-id={id}
        $active={$active}
        $static={$static}
        $disabled={$disabled}
        {...rest}
      >
        <div>{content}</div>
        {children}
      </StyledButton>

      {tooltipContent && <Tooltip id={id}>{tooltipContent}</Tooltip>}
    </>
  );
};

export const Island: React.FC<IslandProps> = ({ size, children, ...props }) => {
  return (
    <StyledContainer size={size} {...props}>
      {children}
    </StyledContainer>
  );
};
